import { Box } from "@mui/material";

function Loading() {
    return (
        <Box height="100%" width="100%">
            Loading...
        </Box>
    );
}

export default Loading;
